<template>
  <Modal
    v-model="state"
    :title="title"
    width="820"
    class-name="vertical-center-modal"
    :mask-closable="false"
    @on-visible-change="bindGetData"
  >
    <div class="c-body">
      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field row-item-must">卡片主图</span>
        </Col>
        <Col span="12">
          <cardptom-icon v-model="cardInfo.image_id" :url="sourceUrl" @on-select="selectLogo" />
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field row-item-must">卡片标题</span>
        </Col>
        <Col span="12">
          <input-len
            v-model="cardInfo.title"
            placeholder="最多7个字，1个中文=1个英文=1个字"
            :max="7"
            charset="init"
            width="360"
          ></input-len>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field row-item-must">推广卖点</span>
        </Col>
        <Col span="12" style="margin-left: -3px">
          <Button type="primary" icon="md-add" @click="addPointList" :disabled="pointLen === 10">推广卖点</Button>
          <span style="margin-left: 10px">已选：{{ pointLen }}/10</span>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field">&nbsp;</span>
        </Col>
        <Col span="12">
          <card-caption v-model="cardInfo.product_selling_points" :max-len="9" :width="360" :del="pointLen > 1"></card-caption>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field row-item-must">行动号召</span>
        </Col>
        <Col span="12">
          <Select v-model="cardInfo.button_text" filterable style="width: 300px" transfer>
            <Option v-for="action in callToAction" placeholder="请选择行动号召" :key="action" :value="action" :label="action"></Option>
          </Select>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field row-item-must">智能优选</span>
        </Col>
        <Col span="12">
          <i-Switch v-model="cardInfo.enable_personal_action" :true-value="1" :false-value="0"></i-Switch>
        </Col>
      </Row>

      <Row class="row-item" :gutter="12">
        <Col span="4" class="col-item">
          <span class="item-field row-item-must">组件名称</span>
        </Col>
        <Col span="12">
          <input-len
            v-model="cardInfo.component_name"
            placeholder="标题建议1-20个字，1个中文=1个英文=1个字"
            :max="20"
            charset="init"
            width="360"
          ></input-len>
        </Col>
      </Row>
    </div>
    <uploader
      v-model="creativeModel"
      type="logo"
      smart=""
      :multiple="false"
      :media="10"
      :width="108"
      :height="108"
      :default-option="gameId"
      @on-upload="uploadFileHandler"
      @on-cancel="creativeModel = false"
    ></uploader>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="false" @click="submitCard">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import CardptomIcon from '@/components/cardptom/icon.vue'
import { isArray, isEmpty } from '@/common/js/utils'
import Uploader from '@/views/create/toutiao_local/components/idea/uploader'
import InputLen from '@/components/input/input-len'
import CardCaption from '@/components/card-caption.vue'
import { callToAction } from '@/data/toutiao/enum'
export default {
  name: 'addCard',
  components: { CardptomIcon, Uploader, InputLen, CardCaption },
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    gameId: {
      type: [Number, String]
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    pointLen() {
      if (this.cardInfo && this.cardInfo.product_selling_points) {
        return this.cardInfo.product_selling_points.length
      } else {
        return 0
      }
    },
    title() {
      return this.edit ? '修改卡片' : '新建卡片'
    },
    edit() {
      return Object.keys(this.info).length !== 0
    }
  },
  watch: {
    info: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    bindGetData(val) {
      if (!this.edit) {
        this.cardInfo = {
          image_id: '',
          title: '',
          product_selling_points: [''],
          button_text: '',
          component_name: '',
          enable_personal_action: 0
        }
      }
    },
    updateInfo() {
      if (this.edit) {
        const { component_name, image_id, title, product_selling_points, button_text, image_url, enable_personal_action } = this.info
        this.$set(this, 'cardInfo', {
          image_id,
          title,
          product_selling_points,
          button_text,
          component_name,
          enable_personal_action
        })
        this.sourceUrl = image_url
      }
    },
    selectLogo(val) {
      this.creativeModel = true
    },
    // 选完素材回调
    uploadFileHandler(list) {
      // 判断服务端错误
      if (isArray(list)) {
        const pop = list.pop()
        if (pop) {
          this.$set(this.cardInfo, 'image_id', String(pop.id))
          this.sourceUrl = pop.url
        }
      } else console.log('上传素材返回错误')

      // 关闭对话框
      this.creativeModel = false
    },
    // 增加推广卖点
    addPointList() {
      this.cardInfo.product_selling_points.push('')
    },
    submitCard() {
      // 校验
      const { image_id, title, product_selling_points, button_text, component_name } = this.cardInfo
      const emptyPoints = product_selling_points
        .map((ret, idx) => {
          return { name: ret, idx: ++idx }
        })
        .filter((ret) => isEmpty(ret.name))
      const errPoints = product_selling_points
        .map((ret, idx) => {
          return { name: ret, idx: ++idx }
        })
        .filter((ret) => ret.name && (ret.name.length < 6 || ret.name.length > 9))
      if (!image_id) {
        this.$Message.warning('卡片主图不能为空')
        return false
      } else if (!title || title.length > 7) {
        this.$Message.warning('卡片标题不能为空且最多7个字')
        return false
      } else if (emptyPoints.length) {
        this.$Message.warning(`第${emptyPoints.map((ret) => ret.idx).join(',')}个推广卖点不能为空`)
        return false
      } else if (errPoints.length) {
        this.$Message.warning(`第${errPoints.map((ret) => ret.idx).join(',')}个推广卖点长度应为6-9个字`)
        return false
      } else if (!button_text) {
        this.$Message.warning('行动号召不能为空')
        return false
      } else if (!component_name || component_name.length > 20) {
        this.$Message.warning('组件名称不能为空且最多20个字')
        return false
      } else {
        if (this.edit) {
          this.$Modal.confirm({
            title: '系统提示',
            content: '修改组件信息，会触发该组件关联的所有计划状态变为审核中，是否确认提交修改？',
            onOk: () => {
              this.$emit('on-edit', this.cardInfo)
            }
          })
        } else this.$emit('on-create', this.cardInfo)
      }
    }
  },
  data() {
    return {
      creativeModel: false, // 选择LOGO弹窗
      sourceUrl: '', // logo 数据源返显
      cardInfo: {
        image_id: '',
        title: '',
        product_selling_points: [''],
        button_text: '',
        component_name: '',
        enable_personal_action: 0
      },
      callToAction // 行动号召枚举值
    }
  },
  mounted() {
    this.$nextTick(() => {})
  }
}
</script>
<style lang="scss" scoped>
.c-body {
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  max-height: 620px;
}

::v-deep .row-item {
  margin-bottom: 16px;
}
</style>
